
import { defineComponent } from "vue";

export default defineComponent({
    name: "ThumbUp",
    props: {
        color: {
            type: String,
            default: "#2AAC7A",
        },
    },
});
